import { CarrierSubmission } from '../types/carrier-submission';
import { Submission } from '../types/submission';

export interface CarrierSubmissionFieldConfigProps {
    isRequired: boolean;
    nestedRequiredFields?: string[];
}

type CarrierSubmissionFieldsConfig = {
    [key in keyof CarrierSubmission | keyof Submission]?: CarrierSubmissionFieldConfigProps;
};

export const carrierSubmissionFieldsConfig: CarrierSubmissionFieldsConfig = {
    insuredName: { isRequired: true },
    agentName: { isRequired: true },
    coverageLines: { isRequired: true },
    dueDate: { isRequired: true },
    insuredMailingAddress: {
        isRequired: true,
        nestedRequiredFields: ['line1', 'city', 'postalCode', 'state', 'country'],
    },
    industry: { isRequired: true },
    sic: { isRequired: true },
    natureOfBusiness: { isRequired: true },
    fein: { isRequired: true },
    businessEmail: { isRequired: false },
};
